module.exports = __webpack_public_path__ + "static/media/exhibition-services-img4.b7a6a684.jpg";